/* eslint-disable consistent-return */
/* eslint-disable import/no-unresolved */
import { useEffect } from 'react';

import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import { isOptions } from 'helpers/assetUtils';
import { isFutures, isSpotContract } from 'helpers/utils';
import {
  lastTradePriceMovementSelector,
  lastTradePriceSelector,
} from 'selectors/priceSelectors';
import { selectedProductSelector, contractTypeSelector } from 'selectors/tradeSelectors';
import { useAppSelector } from 'storeHooks';
import { ContractType } from 'types/IProducts';

const getContractName = contractType => {
  switch (contractType) {
    case 'futures':
      return `futures trading`;
    case 'perpetual_futures':
      return `Perpetual Swaps`;
    case 'interest_rate_swaps':
      return `interest rate swap trading`;
    case 'spreads':
      return `Spreads`;
    case 'spot':
      return `Spot Market`;
    case 'call_options':
      return `Options Chain`;
    case 'put_options':
      return `Options Chain`;
    case 'move_options':
      return 'Straddle Contracts';
    default:
      return '';
  }
};

const changeTitle = (
  lastTradePrice,
  lastTradePriceMovement,
  contractType,
  location,
  product
) => {
  const {
    short_description: shortDescription,
    underlying_asset: underlyingAsset,
    spot_index: spotIndex,
    contract_unit_currency: contractUnitCurrency,
    contract_type: productContractType,
  } = product || {};
  const arrow = lastTradePriceMovement === 'up' ? '▲' : '▼';
  const priceInfo = lastTradePrice
    ? `${arrow} ${lastTradePrice} ${
        spotIndex?.config?.quoting_asset ?? contractUnitCurrency
      }`
    : '';
  const exchangeSuffix = !IS_INDIAN_EXCHANGE ? ' Global' : '';
  const path = location.pathname.split('/');

  const getTitleByContractType = () => {
    const baseTitle = `Trade ${
      isSpotContract(productContractType)
        ? contractUnitCurrency
        : underlyingAsset?.name || ''
    } ${getContractName(productContractType)}`;

    switch (true) {
      case productContractType === ContractType.MoveOptions:
        return `Trade ${underlyingAsset?.name} ${getContractName(productContractType)}`;

      case isOptions(productContractType):
        return `Trade ${underlyingAsset?.name || ''} ${
          shortDescription?.toLowerCase().includes('call') ? 'Call' : 'Put'
        } ${getContractName(productContractType)}`;

      case isFutures(productContractType):
        return `${priceInfo} | ${baseTitle}`;

      case isSpotContract(productContractType):
        return `${priceInfo} | ${baseTitle}`;

      default:
        return baseTitle;
    }
  };

  const updatedTitle = (() => {
    if (path[1] === contractType && path[2] === 'trade') {
      return `${getTitleByContractType()} - Delta Exchange${exchangeSuffix}`;
    }
  })();
  if (updatedTitle) {
    document.title = updatedTitle;
  }
};

const useChangeTitle = (price, moment) => {
  const product = useAppSelector(selectedProductSelector);
  const lastTradePrice = lastTradePriceSelector();
  const lastTradePriceMovement = lastTradePriceMovementSelector();
  const contractType = useAppSelector(contractTypeSelector);
  const location = useAppSelector(state => state.router.location);

  useEffect(() => {
    changeTitle(
      price || lastTradePrice,
      moment || lastTradePriceMovement,
      contractType,
      location,
      product
    );
    // eslint-disable-next-line
  }, [lastTradePrice, lastTradePriceMovement, contractType, location, price, moment]);
};

export default useChangeTitle;
